import { render, staticRenderFns } from "./Param.vue?vue&type=template&id=64ae1b76&scoped=true&"
import script from "./Param.vue?vue&type=script&lang=js&"
export * from "./Param.vue?vue&type=script&lang=js&"
import style0 from "./Param.vue?vue&type=style&index=0&id=64ae1b76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ae1b76",
  null
  
)

export default component.exports